import { Routes } from '@angular/router';
import { AdmtechFormComponent } from './admtech-form/admtech-form.component';
import { AdmtechListComponent } from './admtech-list/admtech-list.component';


export const TECH_ROUTES: Routes = [
    { path: 'list', component: AdmtechListComponent },
    { path: 'add/:idtier1', component: AdmtechFormComponent },
    { path: 'edit/:id', component: AdmtechFormComponent },
    { path: '**', pathMatch: 'full', redirectTo: 'list'}
];